var throwMissingParam = function (name) {
    throw new Error("Missing ".concat(name, " param in selector"));
};
export var secondParam = function (_first, second) {
    return second || throwMissingParam('second');
};
export var thirdParam = function (_first, _second, third) {
    return third || throwMissingParam('third');
};
